import { render, staticRenderFns } from "./SampleEditImages.vue?vue&type=template&id=4cf6710e"
import script from "./SampleEditImages.vue?vue&type=script&lang=js"
export * from "./SampleEditImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports